import { QuantityCounterInputModel } from '@libs/form/models';

export const ProductCounterData: QuantityCounterInputModel = {
  type: 'quantityCounter',
  label: '',
  name: 'productQuantity',
};
